import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const Dropdown = ({ children }) => {
  const [isActive, setActive] = useState(false);
  const toggle = () => setActive(!isActive);
  const ref = useRef();

  const discardDropdown = (evt) => {
    if (!ref.current.contains(evt.target)) {
      setActive(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', discardDropdown);
    return () => window.removeEventListener('click', discardDropdown);
  }, []);

  return (
    <div className="dropdown" ref={ref}>
      {children({ isActive, toggle })}
    </div>
  );
};

Dropdown.propTypes = {
  children: PropTypes.func.isRequired,
};

export default Dropdown;
